import NewDesign from 'components/NewDesign';
import React from 'react';
import Props from '../../Components/Props';
import JSXCode from '../../Components/JSXCode';

const TabBadge = () => {
  return (
    <div className='component:TabBadge'>
      <NewDesign.Typography className='tw-text-xl tw-mb-2' component='p'>
        Badge V1
      </NewDesign.Typography>
      <div className='tw-flex tw-gap-1'>
        <NewDesign.Badge color='primary'>Primary</NewDesign.Badge>
        <NewDesign.Badge color='success'>Success</NewDesign.Badge>
        <NewDesign.Badge color='warning'>Warning</NewDesign.Badge>
        <NewDesign.Badge color='danger'>Danger</NewDesign.Badge>
        <NewDesign.Badge color='secondary'>Secondary</NewDesign.Badge>
      </div>

      <NewDesign.Typography className='tw-text-xl tw-mb-2 tw-mt-4' component='p'>
        Badge V2
      </NewDesign.Typography>
      <div className='tw-flex tw-gap-1'>
        <NewDesign.Badge color='primary' v2>
          Primary
        </NewDesign.Badge>
        <NewDesign.Badge color='success' v2>
          Success
        </NewDesign.Badge>
        <NewDesign.Badge color='warning' v2>
          Warning
        </NewDesign.Badge>
        <NewDesign.Badge color='danger' v2>
          Danger
        </NewDesign.Badge>
        <NewDesign.Badge color='secondary' v2>
          Secondary
        </NewDesign.Badge>
      </div>

      <div className='tw-mt-3'>
        <JSXCode
          code={`<div id="example">
        <NewDesign.Badge color='primary'>Primary</NewDesign.Badge>
        <NewDesign.Badge color='primary' v2>Primary</NewDesign.Badge>
</div>`}
        />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'children',
            type: 'any',
            default: 'undefined',
          },
          {
            prop: 'className',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'style',
            type: 'object',
            default: 'undefined',
          },
          {
            prop: 'color',
            type: `"primary" | "success" | "warning" | "danger" | "secondary"`,
            default: 'primary',
          },
          {
            prop: 'v2',
            type: 'boolean',
            default: 'false',
          },
        ]}
      />
    </div>
  );
};

export default TabBadge;
